// Keeps the free gifts in step with the cart.
//
// The rules live in the EG Gifts theme settings and reach the page through eg-gift-rules.liquid,
// so they hold wherever a qualifying product was added from: the product page, a
// collection, quick add or a recovered cart. On every cart change the qualifying items
// are counted and each gift is added, re-counted or removed to match.
//
// Managed lines carry `_eg_gift`, the slot of the rule that granted them, which is what
// the cart templates key off to hide the remove button and the links.
(() => {
  const root = window.Shopify?.routes?.root || '/';
  const config = document.querySelector('[data-eg-gift-rules]');
  if (!config) return;

  let rules = [];
  try {
    rules = JSON.parse(config.textContent).rules || [];
  } catch (error) {
    return;
  }
  if (!rules.length) return;

  const post = (url, body) =>
    fetch(`${root}${url}`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body),
    });

  // Qualifying products are known by tag, which cart.js does not carry, so the count comes
  // from the same Liquid rule the product page progress uses.
  const countPairs = async () => {
    const response = await fetch(`${root}?section_id=api-eg-cart-pairs`);
    if (!response.ok) throw new Error('pairs');
    const html = new DOMParser().parseFromString(await response.text(), 'text/html');
    const count = Number(html.querySelector('eg-cart-pairs')?.dataset.count);
    if (Number.isNaN(count)) throw new Error('pairs');
    return count;
  };

  let running = false;
  let again = false;

  const sync = async () => {
    // A change that lands mid-sync is picked up by one more pass rather than dropped.
    if (running) {
      again = true;
      return;
    }
    running = true;

    try {
      const cart = await (await fetch(`${root}cart.js`)).json();
      const managed = new Map();
      cart.items.forEach((item) => {
        const slot = Number(item.properties?._eg_gift);
        if (slot) managed.set(slot, item);
      });
      const count = await countPairs();

      const updates = {};
      const additions = [];

      rules.forEach((rule) => {
        const wanted = count >= rule.min ? (rule.perItem ? count : rule.quantity) : 0;
        const line = managed.get(rule.slot);

        if (line) {
          if (line.quantity !== wanted) updates[line.key] = wanted;
        } else if (wanted > 0) {
          additions.push({
            id: rule.variant,
            quantity: wanted,
            properties: { _eg_gift: String(rule.slot) },
          });
        }
      });

      if (!additions.length && Object.keys(updates).length === 0) return;

      // Removals go first so a cart at its line limit still has room for what follows.
      if (Object.keys(updates).length) await post('cart/update.js', { updates });
      if (additions.length) await post('cart/add.js', { items: additions });

      document.dispatchEvent(new CustomEvent('theme:cart:refresh', { bubbles: true }));
    } catch (error) {
      console.error(error);
    } finally {
      running = false;
      if (again) {
        again = false;
        sync();
      }
    }
  };

  document.addEventListener('theme:cart:change', sync);
  sync();
})();
